import React from "react";

import "./NavToggle.scss";

interface NavToggleProps {
  isReportActive: boolean;
  onToggle: (active: boolean) => void;
}

const NavToggle = ({ isReportActive, onToggle }: NavToggleProps) => {
  return (
    <div className="toggle-container">
      <div
        className={`toggle-switch ${isReportActive ? "active" : ""}`}
        onClick={() => onToggle(!isReportActive)}
        role="switch"
        aria-pressed={isReportActive}
      >
        <span className={`toggle-option b4 ${isReportActive ? "selected bold" : ""}`}>Report</span>
        <span className={`toggle-option b4 ${!isReportActive ? "selected bold" : ""}`}>Collect</span>
      </div>
    </div>
  );
};

export default NavToggle;
